import React, { useRef, useEffect, useState } from "react";
import { Link } from 'react-router-dom';

import NuLoading from 'components/nubox/NuLoading';
import NuProgress from 'components/nubox/NuProgress';
import ItemRowFile from './ItemRowFile'

import axios2 from 'services/axios2';

import './styles.css'
//import './nuCheckBox.css'
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const rowObj = {
  id: 0,
  image: "",
  nombre: "",
  detalle: "",
  tam: '',
  progress:0,
  filename:'',
  url: '',
  file: undefined,
  estado:0,
}

class FileUpload2 extends React.Component {

  inputFileRef = React.createRef();

  constructor(props) {
    super(props);

    this.state={
      isloaging:false,

      selectedFiles: undefined, /*[]*/
      
      message: "",

      //multiple:false,   /* permite multiples archivos */
      allowExt:"image/*",
      maxFileSize:1000000,
      saveUrl: '',
      removeUrl:'',
      
      data:[], //para el render de lista de items
    }
    
  }
  //----------------------------------------------
  //-------------------------------------------
  //-- seleccionar un archivo o multiples archivos
  //-- selectedFiles
  chooseFile = (e) => {
    e.preventDefault();
    
    console.log("chooseFile");
    //uploadImage_Click();
    this.inputFileRef.current.click();
    
  }
  //--- una vez que se haga la seleccion de archivos
  //--- se desencadena esta funcion
  //-------------------------------------------
  uploadImage_Change(event) {
    console.log("uploadImage_Change")
    //--- asigna todo el array de archivos
    
    this.setState({ selectedFiles: event.target.files })
    
      //-- para un solo archivo
      //this.setState({ selectedFiles: event.target.files[0] })
    
    const files = event.target.files;
    console.log(files );
    //FileList {0: File, length: 1}
    for (let i = 0; i < files.length ; i++)
    {
      console.log("entre")
      //--  colocamos los archivos en la lista 
      let file = files.item(i)
      /*console.log(file.name)
      console.log(file.size)
      console.log(file.type)*/
      //var url = URL.createObjectURL(e.target.files[0]);
      var url = URL.createObjectURL(file);
      //---agregamos al array
      let obj = {
        id: 0,
        image: "",
        nombre: file.name,
        detalle: file.size,
        tam: file.size,
        progress:0,
        estado:0,
        url: url,
        file: file, /* aqui esta el event.target.files[0]  */
      }
      this.add_row(obj)
    }
    
    

    //---- llamamos a procesar cola
    if(this.props.autoUpload===true){
      this.procesarCola();
    }
    //---------------------
    
    
  }
 
  // 1000000 = 1MB 
  //==================== agregamos nueva fila
  add_row = ( miObj )=>{
    //eliminamos el row, falta hacer
    let valorNuevo= {...miObj };
    //valorNuevo.id=this.state.data.length+1;
    valorNuevo.id=this.state.data.length;
    
    let lista= this.state.data;
    lista.push(valorNuevo);

    //let dataNuevo= {...this.state.data, miObj};
    //valorNuevo.id= this.state.data.length+1; //el nuevo id
    //console.log("miObj")
    console.log(miObj)
    this.setState({ data: lista});
    //setRows([...rows, { name: '', age: '' }]);
  }
  delete_row = (i)=>{
    const arrayCopy = this.state.data;
    arrayCopy.splice(i, 1);

    this.setState({ data : arrayCopy });// asigna todo el objeto
  }
  cell_change = (index,columnId, value )=>{
    const newData = [...this.state.data ];
    newData[index][columnId] = value;

    this.setState({ data: newData });
  }
  //==================================================
  uploadFiles_clic =(e)=>{
    e.preventDefault()
    this.procesarCola();

  }
  //-------------------------
  //-------- subimos los archivos uno a uno
  procesarCola=()=>{
    console.log (this.state.data)

    const items = this.state.data;
    //console.log(files );
    //FileList {0: File, length: 1}
    for (let i = 0; i < items.length ; i++)
    {
      let obj1 = items[i]
      console.log("------obj1-----------")
      console.log(obj1)

      if(obj1.estado===0){
        this.uploadImage(obj1.file, i)
      }
      
    }
  }
  //-----------------------------------------------------------
  //async uploadImage(file, index) {
  async uploadImage(file, index) {
    console.log("uploadImage")
    //---------------------
    const URL = "file_upload_save";
    const data = new FormData();
    data.append("name", "my-picture");
    //data.append("imageFile", event.target.files[0]);
    data.append("txtFile", file );

    const config = {
        header: {
            "Content-Type": "image/png",
        },
        //onUploadProgress: function (progressEvent){
        onUploadProgress: progressEvent=>{
          const percentCompleted =(progressEvent.loaded / progressEvent.total)*100
          console.log("percentCompleted")
          console.log(percentCompleted)
          //bar.setAttribute('value',percentCompleted)
          //bar.previusElementSibling.textContent = `${percentCompleted}%`
          
          this.cell_change(index,"progress",  percentCompleted )  //porcentaje

          if(percentCompleted===100){
            //upload complete!
          }
        }
    };
    
    this.setState({ isloaging: true})

    axios2.post(URL, data, config)
    .then(response => {
        console.log(response.data);
        //this.availabilityMessage = response.data.message;
        this.setState({ isloaging: false})

        if(response.data.exito===0){
          //this.setState({ mensaje: response.data.mensaje });
          this.cell_change(index,"detalle", "Error al procesar" )
          this.cell_change(index,"estado", 2 )  //error al subir
        }else{
          //------ correcto ---
          //props.okImage(response.data.filename);
          console.log(response.data.filename)
          console.log("index:" + index)
          this.cell_change(index,"detalle", response.data.mensaje )
          this.cell_change(index,"estado", 1 ) //correcto
          this.cell_change(index,"filename", response.data.filename )
        }
        //let aux = process.env.REACT_APP_AFILES + response.data.filename;
        //setImageUrl(aux);
        //setFileName( response.data.filename);
        

    }).catch(function (error) {
        // this.availabilityMessage = false;
        console.log(error);
    });
  }
  //---------------------------------------
  onHandleOK=()=>{
    console.log("onHandleOK")
    //----llamamos a afuera
    //---- tenemos que enviar pares de valores, filename y nombre
    let arr = this.json_normalize()
    //console.log( this.state.data )
    this.props.handleOK(arr)
  }
  //-----------------------------------------
  //--- lo normalizamos a 2 columnas
  /*[
    {
        "id": 0,
        "image": "",
        "nombre": "importar-est.csv",
        "detalle": "Registrado correctamente.",
        "tam": 2295,
        "progress": 100,
        "estado": 1,
        "url": "blob:http://localhost:3000/d6433a58-c77f-44e3-b3e1-c6952f19aaa8",
        "file": {},
        "filename": "0iVs1744170420.csv"
    }
  ]*/
  json_normalize=()=>{
    let newData = this.state.data
    // Create empty array
    let arr = [];
    for(const item of newData){
      console.log(item)
      const obj={ nombre: item.nombre,
                  filename: item.filename
                }
      arr.push(obj)
    }
    return arr;
  }
  //------------------------------------------
  cancelar_click=(e)=> {
    e.preventDefault();

    //props.cancelImage();
  }

  
   //------------------------------
   render() {
    //multiple = true, permite multiples archivos
    return (
    <>
      <div className="">
        {/* imageUrl */}
        {
          //JSON.stringify( this.state.data )
        }
        <div className="nufile_layout nufile_layout_rows nufile_border"
              style={{ minHeight: 150 }}
              >
          {/* --------toolbar-------- */}
          <nav  className="nufile_toolbar nufile_widget">
            <ul className="nufile_navbar_horizontal nufile_navbar">
              <li className="">
                <button className="nufile_button nufile_toolbar_button "
                        onClick={ this.chooseFile }>
                  <i className="fa fa-plus" ></i>&nbsp;Seleccionar
                </button>
              </li>

              { this.state.autoUpload && 
                <li className="">
                  <button className="nufile_button nufile_toolbar_button "
                          onClick={(e)=> this.uploadFiles_clic(e) }>
                    <i className="fa fa-plus" ></i>&nbsp;Upload
                  </button>
                </li>
                
              }
              <li>
                <NuLoading text="Cargando...." show= { this.isloaging }/>
              </li>

            </ul>
          </nav>
          {/*<!-- content-->*/}
          <div className="nufile_contenedor nufile_layout_cell" 
               style={{ flex: '1 1 auto', overflow: 'auto' }}>
            
            <table role="presentation" className="table table-striped m-0">
              <tbody className="files">
                {/* -- recorremos cada uno de los items -- */}
                {this.state.data.map((item, index) => (
                  <ItemRowFile
                    key={ index }
                    nombre = { item.nombre }
                    detalle = { item.detalle }
                    tam = { item.tam }
                    estado ={ item.estado }
                    progress = {item.progress}
                    url = { item.url }
                    handleDel= {()=> this.delete_row(index) }
                    urlFile = { process.env.REACT_APP_AFILES + item.filename } 
                  />
                ))}
              </tbody>
            </table>
              {/*-------- item----- */}
            
          </div>
        </div>

              
        <br/>
        <div style={{ textAlign: 'center'}}>
        <Button className="btn btn-primary" 
                onClick={this.onHandleOK} >Aceptar
        </Button>

        <Button className="btn btn-default" 
                onClick={ this.props.handleCancel } >Cancelar 
        </Button>
        </div>
        {/*   botones  */}
        <div>
          <input
            className="form-control form-control-lg"
            type="file"
            ref={ this.inputFileRef}
            value={ this.selectedFile}
            onChange={(e) => this.uploadImage_Change(e)}
            style={{display: "none" }}
            multiple={ this.props.multiple }
          />         
        </div>
        {/*<!-- -->*/}
      </div>
    </>
    )
  }
}
  
export default FileUpload2;


